@if (data.title) {
  <h2 data-typography="bodyLarge" mat-dialog-title>{{ data.title }}</h2>
}
<mat-dialog-content>
  <p data-typography="bodyMedium">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button data-typography="bodyMedium" (click)="onConfirm()">
    {{ data.confirmButtonText }}
  </button>
  <button mat-button mat-dialog-close (click)="onCancel()">
    {{ data.cancelButtonText }}
  </button>
</mat-dialog-actions>
